var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","disabled":_vm.copied,"icon":""},on:{"click":function($event){return _vm.copy(_vm.content)}}},[_c('v-icon',{staticClass:"align-center"},[_vm._v(_vm._s(_vm.copied ? _vm.mdiCheck : _vm.mdiContentCopy))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }